import React from "react"
import { Box, Switch, Typography } from "@mui/material"
import { dsColorNew } from "@palette"
import { AppAcrissAutocomplete } from "@components/Autocomplete"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"
import { enrichFilterIds } from "Pages/DsRepricing/Page/@utils/filterEnrich"

export default function DsRepricingFilterAcriss() {
	const d = dsRepricingDrawerData.peek()
	const { dataInfo: acrissInfo, setDataInfo: setAcriss } = useDsRepricingDataInfo(d.filterAcriss ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useDsRepricingDataInfo(d.filterAcrissExclusion ?? false)

	const isExclusion = exclInfo.value
	const acriss = acrissInfo.value ?? []

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
				<Switch checked={isExclusion} onChange={e => setExcl(e.target.checked, 'filterAcrissExclusion')} size="small"/>
				<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, fontWeight: 500 }}>
					{isExclusion ? 'Exclude acriss' : 'Include acriss'}
				</Typography>
			</Box>
			<AppAcrissAutocomplete
				label="ACRISS"
				placeholder={isExclusion ? 'All ACRISS except…' : 'All ACRISS'}
				value={acriss.map(o => o?.value ?? o)}
				onChange={(_, opts) => setAcriss(opts ?? [], 'filterAcriss')}
				onAjax={options => { enrichFilterIds('filterAcriss', options, dsRepricingDrawerData, dsRepricingOriginalData); return options }}
			/>
		</Box>
	)
}